module.exports = __webpack_public_path__ + "static/assets/1037e4f7d73d9c16a581ad815996eb28.png";